var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { colorPreset } from './colorPreset';
import { Color, Styled } from './style';
var PlaylistColor = /** @class */ (function (_super) {
    __extends(PlaylistColor, _super);
    function PlaylistColor(props) {
        var _this = _super.call(this, props) || this;
        _this.renderColorPreset = function () { return colorPreset.map(function (color, i) { return (React.createElement(Color, { isSelected: _this.state.color === color.background, background: color.background, key: i, onClick: function () { return _this.onColorChange(color.background); } })); }); };
        _this.onColorChange = function (color) {
            _this.setState({ color: color });
            if (_this.props.callback) {
                _this.props.callback(color);
            }
        };
        _this.state = {
            color: props.background,
        };
        return _this;
    }
    PlaylistColor.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.background !== prevProps.background) {
            this.setState({
                color: this.props.background,
            });
        }
    };
    PlaylistColor.prototype.render = function () {
        return (React.createElement(Styled, null,
            React.createElement("section", { className: "preview" },
                React.createElement("div", { className: "thumbnail", style: { background: this.state.color } })),
            React.createElement("aside", { className: "color-picker" },
                React.createElement("div", { className: "color-preset" }, this.renderColorPreset()))));
    };
    return PlaylistColor;
}(React.Component));
export default PlaylistColor;
//# sourceMappingURL=index.js.map